module.exports = __webpack_public_path__ + "img/logoUJED.972c4180.png";